export default __webpack_public_path__ + "imgs/1eb204b2d04e5f0bba01080de7fde93e.jpg";